import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import $ from 'jquery';
import Header from "./Header1.js";
import "../App.css"
import { Link, redirect } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser,faCreditCard,faEnvelope,faPhone,faBuilding,faFlag,faDollar } from '@fortawesome/free-solid-svg-icons'
import Button from "react-bootstrap/esm/Button.js";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import {formatDate, parseResponseJSON,dateDifference} from "./CommonFunctions";
import InputGroup from 'react-bootstrap/InputGroup';
import {Row,Col,Table} from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import CommonComponents from "./CommonComponents.js";
import { Rate , Divider, Input} from "rsuite";
import NewPost from "./AddImage.js"
import Cookies from 'js-cookie';

import { Box, Dialog, DialogActions, DialogContent, DialogTitle,
     FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment';
import { NumericFormat } from "react-number-format";
import { getUserMail, getUserName } from "./Auth.js";

export const AddCashout=({setShowAddCashout,showAddCashout,currentCashout,expectedAmount})=>{
 const [Cashout,setCashout] = useState(currentCashout!=null ? currentCashout :{
         id:null,
         amount:0,
         expectedAmount:expectedAmount,
         depositDate: formatDate(new Date()),
         depositedBy:getUserName(),
         remarks:"",
         bankName:"",
        
     })
     const {displayNotificationMessage}=useContext(CommonComponents);
     const totalAmount=4500;
    const url=process.env.REACT_APP_SERVER_URL;
    useEffect(() => {
      
    
    }, []);
    function handleCloseCashout(){
        setShowAddCashout(false);
    }

    const saveDeposit = async()=>{
        try{
            const response = await axios.post(`${url}/cashDeposits`,Cashout);
            if(response && response.data){
                handleCloseCashout();
                displayNotificationMessage("success",`Cash Deposit added of amount $${Cashout.amount}`);
            }

        }catch(error){
            console.log(error)
        }
    }

  




    return (
      <div>
        <React.Fragment>
      <Dialog
        open={showAddCashout}
        onClose={handleCloseCashout}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            handleCloseCashout();
          },
        }}
      >
        <DialogTitle>
            <Grid container spacing={2} >
            <Grid item xs={12} md={6}>Deposit Details</Grid>
            <Grid item xs={12} md={6}>
                <Grid container spacing={2} >
                    <Grid item xs={12} md={12}>
                        Expected Deposit: <NumericFormat
                        value={Cashout.expectedAmount} thousandSeparator prefix={'$'} displayType="text"/></Grid>
                </Grid>
                
            </Grid>
            </Grid>
        </DialogTitle>
        <DialogContent>
        <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
        <TextField
                        fullWidth
                    label="Deposit Amount"
                    sx={{ m: 1.2 }}
                    type="number"
                    value={Cashout.amount}
                    onChange={(e)=>setCashout((prev) => ({...prev, amount: e.target.value}))}
                    InputProps={{
                        startAdornment: <InputAdornment position="start" >$</InputAdornment>,
                    }}
                    InputLabelProps={{
                        sx: {
                        fontSize: "1rem", // Adjust font size
                        },
                    }}
                    variant="standard"
                    />

            </Grid>
            <Grid item xs={12} md={4}>
            <TextField
            autoFocus
            required
            margin="dense"
            name="depositDate"
            label="Deposit Date"
            type="date"
            fullWidth
            variant="standard"
            value={Cashout.depositDate}
            onChange={(e)=>setCashout((prev) => ({...prev, depositDate: e.target.value}))}
          
            sx={{ m: 1.2 }}
            InputLabelProps={{
                sx: {
                  fontSize: "1rem", // Adjust font size
                },
              }}
          />

            </Grid>
            <Grid item xs={12} md={4}>
            <TextField
            autoFocus
            required
            margin="dense"
            name="bankName"
            label="Bank Name"
            type="text"
            fullWidth
            variant="standard"
            value={Cashout.bankName}
            onChange={(e)=>setCashout((prev) => ({...prev, bankName: e.target.value}))}
          
            sx={{ m: 1.2 }}
            InputLabelProps={{
                sx: {
                  fontSize: "1rem", // Adjust font size
                },
              }}
          />

            </Grid>
            
        </Grid>
          
          
                    

                    
        
          <TextField
          fullWidth 
          sx={{ m: 1.2}}
          id="standard-textarea"
          label="Description"
          multiline
          variant="standard"
          value={Cashout.remarks}
          onChange={(e)=>setCashout((prev) => ({...prev, remarks: e.target.value}))}
          InputLabelProps={{
            sx: {
              fontSize: "1rem", // Adjust font size
            },
          }}
        />
        <label style={{color:"grey", margin: "0.4rem" }}>Cashout by {Cashout.depositedBy}</label>

        
    
        
        
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCashout}>Cancel</Button>
          <Button type="submit" onClick={(e)=>{
            saveDeposit();
          }}>Save</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
        




 




      </div>
    );


}